import React, { PropsWithChildren } from 'react';

type Props = {
    children: JSX.Element | JSX.Element[] | string;
    onClick?: any;
    title?: string;
    className?: string;
};
export const BtnTool: React.FC<PropsWithChildren<Props>> = ({ children, onClick, title, className }) => {
    return (
        <button type="button" onClick={() => (onClick ? onClick() : '')} title={title} className={className}>
            {children}
        </button>
    );
};
